interface Props {
  text: string;
}

export function UserMessage({ text }: Props) {
  return (
    <div className="user-message">
      <div className="user-bubble">{text}</div>
    </div>
  );
}
